import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tag',
  standalone: false,
  template: `<span class="badge" [ngClass]="statusClass">{{ value }}</span>`,
})
export class TagComponent {
  @Input() severity: 'success' | 'info' | 'warning' | 'danger' = 'info';
  @Input() value = '';

  private readonly severityMap: Record<string, string> = {
    success: 'status-green',
    danger: 'status-red',
    warning: 'status-yellow',
    info: 'status-grey',
  };

  get statusClass(): string {
    return this.severityMap[this.severity] || 'status-grey';
  }
}
